<template>
  <div class="wrapper">

    <side-bar type="sidebar" :sidebar-links="role=='tutor' ? $sidebar.tutorLinks : $sidebar.sidebarLinks">
   
     <user-menu></user-menu>
     <h5 style='color:white;margin-left:30px'>{{role | capitalize}} Menu</h5> 
      <mobile-menu></mobile-menu>
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import UserMenu from 'src/components/UIComponents/SidebarPlugin/UserMenu.vue'
  import MobileMenu from 'src/components/UIComponents/SidebarPlugin/MobileMenu.vue'

  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      UserMenu,
      MobileMenu
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      }
    },
    computed: {
        role(){
          const token = localStorage.getItem('vuex')
          const parsed = JSON.parse(token)
          const role = parsed['auth']['role']
          console.log('Role: ', role);
          return role
        }
     }
  }

</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/DashboardLayout.vue